<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.BigPackageCode }}</td>
                <td>{{ item.ExportReceiptID }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, packageStatus)}">{{ item.Status | display_value(packageStatus) }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency}}</td>
                <td class="text-right" v-if="(userRole == roleType.Admin || userRole == roleType.Store) && item.Status != packageStatusEnum.DA_XUAT_KHO">
                  <v-edit-dialog :return-value.sync="item.Weight" eager lazy @save="saveItem({ID: item.ID, Weight: item.Weight})">
                      <div>{{ item.Weight | currency('', 2) }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.Weight" type="number" step=".01" label="KG" single-line autofocus></v-text-field>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.Weight | currency('', 2)}}</td>
                <td class="text-right" v-if="(userRole == roleType.Admin || userRole == roleType.Store) && item.Status != packageStatusEnum.DA_XUAT_KHO">
                  <v-edit-dialog :return-value.sync="item.Volume" eager lazy @save="saveItem({ID: item.ID, Volume: item.Volume})">
                      <div>{{ item.Volume | currency('', 2) }}</div>
                      <template v-slot:input>
                        <v-text-field v-model="item.Volume" type="number" step=".01" label="M3" single-line autofocus></v-text-field>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-right" v-else>{{ item.Volume | currency('', 2)}}</td>
                <td class="text-right">{{ item.FeeShip | currency('', 2)}}</td>
                <td>{{ item.StoreTQDate | display_date }}</td>
                <td>{{ item.PackedDate | display_date }}</td>
                <td>{{ item.ExportTQDate | display_date }}</td>
                <td>{{ item.StoreVNDate | display_date }}</td>
                <td>{{ item.MarkedVNDate | display_date }}</td>
                <td>{{ item.ExportVNDate | display_date }}</td>
                <td v-if="userRole != roleType.Customer">{{ item.CreatedBy }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="importDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-card-title>
                <span class="title">Nhập kho VN</span>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap pa-3>
                    <v-flex lg12 md12 sm12 pr-2>
                        <v-autocomplete label="Khách hàng" v-model="importItem.UID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
                    </v-flex>
                    <!-- <v-flex lg12 md12 sm12 pr-2>
                        <v-select v-model="importItem.ProductType" :items="productTypes" item-text="name" item-value="value" label="Loại hàng"></v-select>
                    </v-flex> -->
                    <v-flex lg6 md6 sm12 pr-2>
                        <v-checkbox v-model="isScanner" label="Sử dụng máy quét mã vạch"></v-checkbox>
                    </v-flex>
                    <v-flex lg6 md6 sm12 pr-2>
                        <v-checkbox v-model="isWeightRequire" label="Yêu cầu nhập cân nặng"></v-checkbox>
                    </v-flex>
                    <v-flex lg4 md4 sm12 pr-2>
                        <v-text-field ref="trancode" label="Mã vận đơn" v-model="importItem.TransactionCode" class="input-group--focused" @keyup.enter="pushImportTransaction()" @input="onCodeChanged"></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm12 pr-2>
                        <h-currency-input v-model="importItem.Weight" :decimal="1" label="Cân nặng (kg)" class="input-group--focused" @press_enter="pushImportTransaction()"></h-currency-input>
                    </v-flex>
                    <v-flex lg4 md4 sm12 pr-2>
                        <h-currency-input v-model="importItem.Volume" :decimal="1" label="Thể tích (m3)" class="input-group--focused" @press_enter="pushImportTransaction()"></h-currency-input>
                    </v-flex>
                    <v-flex lg12 md12 sm12 pr-2>
                        <v-data-table
                          :headers="import_headers"
                          :items="import_transactions"
                          :options.sync="import_pagination"
                          :footer-props="import_items_per_page"
                          :mobile-breakpoint="100"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td>{{ item.TransactionCode }}</td>
                              <td class="text-right">
                                <v-edit-dialog :return-value.sync="item.Weight" eager lazy>
                                    <div>{{ item.Weight | currency('', 2) }}</div>
                                    <template v-slot:input>
                                      <v-text-field v-model="item.Weight" type="number" step=".01" label="KG" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                              </td>
                              <td class="text-right">
                                <v-edit-dialog :return-value.sync="item.Volume" eager lazy>
                                    <div>{{ item.Volume | currency('', 2) }}</div>
                                    <template v-slot:input>
                                      <v-text-field v-model="item.Volume" type="number" step=".01" label="M3" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                              </td>
                              <td class="text-center">
                                <v-icon @click="deleteImportTransaction(item)">delete</v-icon>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="importDialog = false">Đóng</v-btn>
                <v-btn color="blue darken-1" text @click="saveData">Cập nhật</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import { request_list } from '@/commons/hpod';
import createPermissionMixin from "@/mixins/permissionMixin";
import Vue from 'vue';
import _ from "lodash";

export default {
  mixins: [createPermissionMixin('small_package')],
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      isScanner: true,
      isWeightRequire: true,
      packageStatus: configs.PACKAGE_STATUS,
      packageStatusEnum: configs.PACKAGE_STATUS_ENUM,
      import_pagination: {...configs.PAGINATION, itemsPerPage: 10},
      import_items_per_page: {'items-per-page-options': [10, 20, 30, 40, 50]},
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "tracking_list",
      productTypes: configs.PRODUCT_TYPE_LIST,
      roleType: configs.ROLE_TYPE,
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      importDialog: false,
      selectedCustomerId: 0,
      importItem: {
        UID: 0,
        Username: '',
        ProductType: 1,
        TransactionCode: '',
        Weight: 0,
        Volume: 0
      },
      import_transactions: [],
      import_headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "",
          value: "",
        }
      ]
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    userRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.hasEditPermission });
    }
  },
  computed: {
    ...mapState({
      customers: state => state.customer.master.data,
      items: state => state.tracking.all.data,
      total_rows: state => state.tracking.all.total,
      currentItem: state => state.tracking.selected,
      loading: state => state.tracking.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let hd = [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          quickSearch: true,
          width: 120,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã bao",
          value: "BigPackageCode",
          sortable: true,
          filterable: true,
          quickSearch: true,
          width: 120,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "YC giao hàng",
          value: "ExportReceiptID",
          sortable: true,
          filterable: true,
          width: 130,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          sortable: true,
          filterable: true,
          width: 120,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.PACKAGE_STATUS
        },
        {
          text: "S.Kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          width: 80,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "KG",
          value: "Weight",
          align: "end",
          decimal: 1,
          filterable: true,
          width: 80,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "M3",
          value: "Volume",
          align: "end",
          decimal: 1,
          filterable: true,
          width: 80,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ký nhận",
          value: "StoreTQDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Đóng bao",
          value: "PackedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Xuất kho TQ",
          value: "ExportTQDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Đã nhập kho",
          value: "StoreVNDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Chờ xuất kho",
          value: "MarkedVNDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Đã xuất kho",
          value: "ExportVNDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        }
      ];
      if(this.userRole != this.roleType.Customer){
        hd.push({
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        });
      }
      return hd;
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("tracking/getList", param);
      
      if(this.userRole != configs.ROLE_TYPE.Customer) {
        this.getCustomerList();
      }
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username"]
      });
    },
    saveItem(item) {
        this.$store.dispatch("storeManager/setDetail", {
          data: item,
          id: item.ID
        });
    },
    import_data() {
      this.importDialog = true;
    },
    saveData() {
      if(this.import_transactions.length > 0) {
        this.$store.dispatch("storeManager/updateMultiple", {
          data: {
            'UID': this.import_transactions[0].UID,
            'Username': this.import_transactions[0].Username,
            'ProductType': this.import_transactions[0].ProductType,
            'Status': 0,
            'Transactions': this.import_transactions
          } 
        });
        this.import_transactions = [];
        this.importDialog = false;
      }
    },
    createBill() {
      if(this.import_transactions.length > 0) {
        this.$store.dispatch("storeManager/updateMultiple", {
          data: {
            'UID': this.import_transactions[0].UID,
            'Username': this.import_transactions[0].Username,
            'ProductType': this.import_transactions[0].ProductType,
            'Status': 0,
            'Transactions': this.import_transactions,
            'IsCreateBill': true
          } 
        });
        this.import_transactions = [];
        this.importDialog = false;
      }
    },
    onCodeChanged() {
      if(this.isScanner) {
        this.pushImportTransaction();
      }
    },
    pushImportTransaction:  _.debounce( function() {
      if(this.importItem.TransactionCode != '' && (!this.isWeightRequire || this.importItem.Weight > 0 || this.importItem.Volume > 0)) {
        if(_.find(this.import_transactions, {'TransactionCode': this.importItem.TransactionCode})) {
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã vận đơn đã tồn tại trong danh sách.');
          return;
        }
        const customer = _.find(this.customers, {'ID': this.importItem.UID});
        // Load thong tin can nang
        var newImportItem = {
          ...this.importItem,
          Username: customer ? customer.Username : ''
        }
        if(newImportItem.Weight == 0 && newImportItem.Volume == 0) {
          var param = {
              filter: [{
                  column: "TransactionCode",
                  value: newImportItem.TransactionCode,
                  condition: "s_equal"
              }
            ]
          };
          request_list('storemanager', ret => {
            if(ret.data.length > 0) {
              newImportItem.Weight = ret.data[0].Weight;
              newImportItem.Volume = ret.data[0].Volume;
            }        
          }, Vue.http, param, this.$store.state.authentication.token);
        }
        
        this.import_transactions.push(newImportItem);
        this.importItem.TransactionCode = '';
        this.importItem.Weight = 0;
        this.importItem.Volume = 0;
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    100,
    {
      leading: false,
      trailing: true
    }
    ),
    deleteImportTransaction(item){
      this.import_transactions = _.filter(this.import_transactions, function(currentObject) {
        return currentObject.TransactionCode !== item.TransactionCode;
      });
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_CREATE_DATA", this.import_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_CREATE_DATA", this.import_data);
  }
};
</script>
